export const en = {
    'other-sign': 'and {number} more',
    'page-name': 'Blocked sites'
};
